import { ThemeConfig, Layout01ThemeCustomizations } from './index';


const Peach: ThemeConfig = {
  page: {
    background: '#f2e6df'
  },
  main: {
    color: '#bf4545',
  },
  link: {
  },
  characteristicFont: {
    fontFamily: '"Playfair Display", sans-serif',
    fontWeight: '400',
    fontSize: '34px',
    lineHeight: '1.176'
  },
  characteristicColor: {
  },
  signatureRequired: {
    background: '#fdd8cf',
    color: '#222222'
  },
  card: {
    background: 'white',
    boxShadow: '-9px 9px 0 #eed9d3'
  },
  layoutSpecific: {
    layout01: {
      cardHeader: {
        color: '#767676'
      },
      recentTrackingDot: {}
    } as Layout01ThemeCustomizations
  }
};

export default Peach;